module.exports = __webpack_public_path__ + "static/media/cq_firma_documento b.cba6046a.svg";